import Record from "./base"

export default class Video extends Record {
  constructor(...args) {
    super(...args)
    const [model, props] = args
  }
}
